module.exports = __webpack_public_path__ + "media/images/redesign-images/home/collegiate-logos/bradley-university-dcb7e7002ab0db0b8f5d2a0a8bca5a3a.svg";